import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AlertService {

    private __dataProvider: Alert[] = new Array<Alert>();
    private __behaviorSubject: BehaviorSubject<Alert[]> = new BehaviorSubject<Alert[]>(null);
    public Cast: Observable<Alert[]>;

    private __dataProviderErr: Alert[] = new Array<Alert>();
    private __behaviorSubjectErr: BehaviorSubject<Alert[]> = new BehaviorSubject<Alert[]>(null);
    public CastErr: Observable<Alert[]>;

    interval;
    intervalErr;

    constructor() {
        this.Cast = this.__behaviorSubject.asObservable();
        this.__behaviorSubject.next(this.__dataProvider);

        this.CastErr = this.__behaviorSubjectErr.asObservable();
        this.__behaviorSubjectErr.next(this.__dataProviderErr);
    }

    add(_title, _message, _type) {
        let _alert = new Alert();
        _alert.Title = _title;
        _alert.Message = _message;
        _alert.Type = _type;
        if (_alert.Type === "Success") {
            this.__dataProvider.push(_alert);
            this.__behaviorSubject.next(this.__dataProvider);
            this.autoDelete();
        } else {
            this.__dataProviderErr.push(_alert);
            this.__behaviorSubjectErr.next(this.__dataProviderErr);
            this.autoDeleteErr();
        }
    }

    delete(indx) {
        this.__dataProvider.splice(indx, 1);
    }

    autoDelete() {
        this.interval = setInterval(() => {
            this.__dataProvider.shift();
            clearInterval(this.interval);
        }, 5000);
    }

    deleteErr(indx) {
        this.__dataProviderErr.splice(indx, 1);
    }

    autoDeleteErr() {
        this.intervalErr = setInterval(() => {
            this.__dataProviderErr.shift();
            clearInterval(this.intervalErr);
        }, 5000);
    }
}

export class Alert {
    Title: string;
    Message: string;
    Type: string;
}
